import type { InjectionKey } from 'vue';
import type { ModularBlocksConfig } from './types';

export const modularBlocksConfigKey: InjectionKey<ModularBlocksConfig> = Symbol('modularBlocksConfig');
